import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./Footer.css";
import Location from '../../images/pin.png'
import telephone from '../../images/telephone.png'
import Email from '../../images/email.png'
import Logo from '../../images/logo.svg'

const Footer = () => {

   const [isScrolled, setIsScrolled] = useState(false);
    const [menuActive, setMenuActive] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
  
    const navigate = useNavigate();    
        const navigateToPage = (page) => {
          navigate(page);
        };
    
    
    useEffect(() => {
      const handleScroll = () => {
        setIsScrolled(window.scrollY > 0);
      };
  
      window.addEventListener("scroll", handleScroll);
  
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  
    const closeMenu = () => {
      setMenuActive(false);
      setDropdownOpen(false);
    };




  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Company Info */}
        <div className="footer-column">
          <div className="footer-logo">
            <img src={Logo} alt="Total Care Advisory" />
          </div>

          <p>
            Providing specialist consultancy services for care providers,
            healthcare organisations, and social care businesses.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-column">
          <h4>Quick Links</h4>
          <nav className={`nav-link ${menuActive ? "active" : ""}`}>
            <NavLink to="/" end onClick={closeMenu}>
              Home
            </NavLink>
            <NavLink to="/about" onClick={closeMenu}>
              About Us
            </NavLink>
            <NavLink to="/services" onClick={closeMenu}>
              Our Services
            </NavLink>
            <NavLink to="/insights" onClick={closeMenu}>
              Insights
            </NavLink>
            <NavLink to="/faqs" onClick={closeMenu}>
              FAQs
            </NavLink>
            <NavLink to="/Registration" onClick={closeMenu}>
              CQC Registration
            </NavLink>
          </nav>
        </div>

        {/* Services */}
        <div className="footer-column">
          <h4>Services</h4>
          <ul>
            <li onClick={() => navigateToPage("Sub-Pages/CQC_Services")}>
              CQC Services
            </li>
            <li onClick={() => navigateToPage("Sub-Pages/Care_Home")}>
              Care Home Sales
            </li>
            <li onClick={() => navigateToPage("Sub-Pages/Capital_Allowance")}>
              Capital Allowance
            </li>
            <li onClick={() => navigateToPage("Sub-Pages/Accounting")}>
              Accounting
            </li>
            <li onClick={() => navigateToPage("Sub-Pages/Software")}>
              Software
            </li>
            <li
              onClick={() => navigateToPage("Sub-Pages/Operational_Management")}
            >
              Operational Management
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-column">
          <h4>Contact Us</h4>

          <div className="contact-item">
            <img src={Location} alt="Location" />
            <p>London, United Kingdom</p>
          </div>

          <div className="contact-item">
            <img src={telephone} alt="Phone" />
            <p>+44 1603267270</p>
          </div>

          <div className="contact-item">
            <img src={Email} alt="Email" />
            <p>info@totalcareadvisory.com</p>
          </div>

          <div className="social-icons">
            <a href="#">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://uk.linkedin.com/company/total-care-advisory">
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a href="#">
              <i className="fab fa-twitter"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;